import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function WebIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="#70707d" strokeLinecap="round" strokeLinejoin="round" d="M8 2a9.18 9.18 0 0 1 2.4 6A9.18 9.18 0 0 1 8 14M8 2a9.18 9.18 0 0 0-2.4 6A9.18 9.18 0 0 0 8 14M8 2a6 6 0 1 0 0 12M8 2a6 6 0 0 1 0 12M2.3 6.2h11.4M2.3 9.8h11.4" /><path stroke="#171717" strokeLinecap="round" strokeLinejoin="round" d="M8 2a9.18 9.18 0 0 1 2.4 6A9.18 9.18 0 0 1 8 14M8 2a9.18 9.18 0 0 0-2.4 6A9.18 9.18 0 0 0 8 14M8 2a6 6 0 1 0 0 12M8 2a6 6 0 0 1 0 12M2.3 6.2h11.4M2.3 9.8h11.4" /></svg>
  );
}

export default WebIcon;
